import { RootState } from "@/store/store";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";
import { filterTreeFiltersAreInvalid } from "@/components/pages/common/filters-tree/utils/helpers/filterTreeFiltersAreInvalid";

export const dimensionsSharedCostsDataIsInvalidSelector = (
  state: RootState,
) => {
  const sharedCosts = dimensionSharedCostsSelector(state);

  let invalid = false;
  let sharedAmountInvalid = false;

  sharedCosts.forEach((sharedCost) => {
    if (invalid || sharedAmountInvalid) {
      return;
    }

    invalid = !sharedCost.name;

    if (invalid) {
      return;
    }

    const sharedAmountSum =
      sharedCost.share_amounts?.reduce((result, item) => {
        result = item.share_amount + result;
        return result;
      }, 0) ?? 0;

    sharedAmountInvalid = sharedAmountSum > 100;

    invalid = filterTreeFiltersAreInvalid(sharedCost.filter_tree);
  });

  return invalid || sharedAmountInvalid;
};
